import request from "root/js/request";

export const postProductCost = async ({ wb_api_key_id, identifier, data }) => {
  const response = await request({
    url: `/analytics/product_cost/`,
    method: "post",
    data: {
      wb_api_key_id,
      identifier,
      data,
    },
  });
  return response.data;
};
